module.exports = __webpack_public_path__ + "img/7_61.dc454e1b.png";